import { Slider } from "antd";
import { useState } from "react";
import "./style.css";
import { getLabel } from "../../../hooks/use-labels";

const InputRangeSlider = (props) => {
  const {
    maxRange,
    minValue,
    variableRange,
    onChange,
    value,
    label,
    name,
    formatId,
    placeholder,
    step,
  } = props;

  const minRange = minValue || 0;
  const rangeValue = variableRange ? value : value[1];
  const [range, setRange] = useState(rangeValue);

  const handleRangeChange = (value) => {
    if (variableRange) {
      setRange(value);
      onChange(value);
    } else {
      setRange(+value <= minValue ? minValue : value);
      onChange([minValue, value]);
    }
  };

  const marks = {
    [minRange]: getLabel("minRangeLabel"),
    [maxRange]: getLabel("maxRangeLabel"),
  };

  return (
    <div className="hex-range-slider input-bottom-margin">
      <Slider
        marks={marks}
        min={minRange}
        max={maxRange}
        step={step || 1}
        range={variableRange || false}
        value={range}
        id={formatId(label || name)}
        onChange={handleRangeChange}
        className="range-slider mb-1 mt-4"
        tooltip={{
          formatter: (value) => (
            <div>
              {value}{" "}
              {placeholder && (
                <span className="placeholder-text">{placeholder || ""}</span>
              )}
            </div>
          ),
        }}
      />
    </div>
  );
};

export default InputRangeSlider;
